import { ErrorToast, SuccessToast } from "../components/toastify";
import { AxiosPostMethod } from "../helpers/customAxios";
import { setShowPreloader } from "../store/activePage";
import HandleLogout from "./handleLogout";

export const getCreateEventErrorMessage = (response) => {
  const rawData = response?.data;
  const message =
    response?.data?.data?.message ||
    response?.data?.data?.error ||
    response?.data?.data ||
    response?.data?.error ||
    response?.data?.message ||
    response?.message;

  if (Array.isArray(message)) {
    return message.filter(Boolean).join(", ");
  }

  if (typeof message === "string" && message.trim()) {
    return message.trim();
  }

  if (typeof rawData === "string" && rawData.trim()) {
    return rawData.trim();
  }

  if (response?.status === 413) {
    return "Uploaded invitation file is too large.";
  }

  return "Unable to create event. Please verify the form details and try again.";
};

const HandleCreateEvent = async (
  values,
  dispatch,
  resetForm,
  continuetoPayment
) => {
  dispatch(setShowPreloader(true));
  const createEvent = await AxiosPostMethod(
    "org/create-event",
    values,
    false,
    true
  );
  if (createEvent?.status === 200) {
    console.log("createEvent", createEvent);
    const eventId = createEvent?.data?.data?.event_id;

    if (eventId) {
      continuetoPayment(eventId);
      SuccessToast("Event Created Successfully");
      resetForm();
    } else {
      dispatch(setShowPreloader(false));
      console.warn("Create event response did not include event_id", createEvent);
      ErrorToast(getCreateEventErrorMessage(createEvent));
    }
  } else {
    dispatch(setShowPreloader(false));
    if (createEvent?.status === 401) HandleLogout();
    console.warn("Create event failed", createEvent);
    ErrorToast(getCreateEventErrorMessage(createEvent));
  }
  return createEvent;
};

export default HandleCreateEvent;
